module.exports = __webpack_public_path__ + "media/images/meta/digi-wedding-ru-8554370b0bec9c00ae1cd9a507d19888.png";